import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "text-center",
  style: {"margin-top":"100px"}
}

import NotClearableInforModal from "@/components/RoleAssignment/NotClearableInforModal.vue"
import ElementPersonInCharge from "@/components/RoleAssignment/ElementPersonInCharge.vue"
import roleAssignAccountType from "@/types/responses/roleAssignAccount"
import ActionButtons from "@/components/RoleAssignment/ActionButtons.vue"
import organizationType from "@/types/requests/organizationType"
import getRole from "@/types/responses/getRole"
import { Ref, ref, computed, watch } from "vue"
import accountType from "@/types/account"
import i18n from "@/lang/i18n"

type requestIdsType = {
  assigns: (roleAssignAccountType | accountType)[],
  unassigns: (roleAssignAccountType | accountType)[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PersonInCharge',
  props: {
    accounts: {},
    displayAssigns: {},
    alreadyAssignedAccountIds: {},
    selectedRole: {},
    modelValue: {},
    windowInnerWidth: {},
    organizations: {},
    changeDisplayAssigns: { type: Function },
    loading: { type: Boolean }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit
const props = __props

const selectedByCandidate: Ref<roleAssignAccountType[]> = ref([])
const selectedByAssigned: Ref<roleAssignAccountType[]> = ref([])
const inforModalStatus: Ref<boolean> = ref(false)

const modelValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit("update:modelValue", value)
  }
})

const unAssignAccounts = computed(() => {
  if (!props.accounts?.length) return []
  return props.accounts.filter((account) => {
    return !props.displayAssigns.find((assignedAccount) => {
      return assignedAccount.id === account.id
    })
  })
})

function addPersonInCharge() {
  modelValue.value.assigns = modelValue.value.assigns.concat(selectedByCandidate.value)
  props.changeDisplayAssigns(selectedByCandidate.value, true)
  deleteAssignsOrUnassigns(modelValue.value.assigns, modelValue.value.unassigns)
  selectedByCandidate.value = []
}

function clearPersonInCharge() {
  if (!isClearableRolesCount()) return inforModalStatus.value = true
  modelValue.value.unassigns = modelValue.value.unassigns.concat(selectedByAssigned.value)
  props.changeDisplayAssigns(selectedByAssigned.value, false)
  deleteAssignsOrUnassigns(modelValue.value.unassigns, modelValue.value.assigns)
  selectedByAssigned.value = []
}

function selectAll() {
  selectedByCandidate.value = JSON.parse(JSON.stringify(unAssignAccounts.value))
}

function isClearableRolesCount() {
  let isClearable = true
  selectedByAssigned.value.forEach((account: roleAssignAccountType) => {
    if (account.roles?.length == 1 && account.roles[0]?.id == props.selectedRole?.id) {
      return isClearable = false
    }
  })
  return isClearable
}

function deleteAssignsOrUnassigns(deleteValues: (roleAssignAccountType | accountType)[], accounts: (roleAssignAccountType | accountType)[]) {
  deleteValues.forEach((deleteValue) => {
    const index = accounts.findIndex((account: roleAssignAccountType | accountType) => account.id === deleteValue.id)
    if (index !== -1) accounts.splice(index, 1)
  })
}

function filterByAccounts(accounts: roleAssignAccountType[]) {
  let filteredAccounts: roleAssignAccountType[] = []
  accounts.forEach((account: roleAssignAccountType) => {
    const isIncluededAccount = selectedByCandidate.value.findIndex((selectedAccount: roleAssignAccountType) => {
      return selectedAccount.id == account.id
    }) != -1
    if (isIncluededAccount) filteredAccounts.push(account)
  })
  selectedByCandidate.value = filteredAccounts
}

watch(() => props.accounts, (value) => {
  if (selectedByCandidate.value?.length) filterByAccounts(value)
})

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_row, { class: "checkbox-with-number-text-form mb-2" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => [
            _createVNode(ElementPersonInCharge, {
              title: _unref(i18n).global.t('pages.roleAssignment.form.result'),
              accounts: unAssignAccounts.value,
              modelValue: selectedByCandidate.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedByCandidate).value = $event)),
              alreadyAssignedAccountIds: [],
              organizations: __props.organizations,
              displayIcon: false,
              loading: props.loading
            }, null, 8, ["title", "accounts", "modelValue", "organizations", "loading"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "1" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(ActionButtons, { action: addPersonInCharge }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode(" ▶︎ ", -1)
                ]))]),
                _: 1
              }),
              _createVNode(ActionButtons, { action: clearPersonInCharge }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode(" ◀︎ ", -1)
                ]))]),
                _: 1
              }),
              _createVNode(ActionButtons, { action: selectAll }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.roleAssignment.form.allSelect')), 1)
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => [
            _createVNode(ElementPersonInCharge, {
              title: _unref(i18n).global.t('pages.roleAssignment.form.targetUser'),
              accounts: props.displayAssigns,
              modelValue: selectedByAssigned.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedByAssigned).value = $event)),
              alreadyAssignedAccountIds: props.alreadyAssignedAccountIds,
              organizations: __props.organizations,
              displayIcon: true,
              loading: props.loading
            }, null, 8, ["title", "accounts", "modelValue", "alreadyAssignedAccountIds", "organizations", "loading"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(NotClearableInforModal, {
      modelValue: inforModalStatus.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((inforModalStatus).value = $event))
    }, null, 8, ["modelValue"])
  ], 64))
}
}

})